export const DMS_MODULE = 'Crm';
